import { userConstants } from "../../constant";

const initialState = {
  updates: [],
};

export function campaignUpdates(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_CAMPAIGN_UPDATES:
      return { ...state, updates: action.updates };
    case userConstants.CREATE_CAMPAIGN_UPDATE:
      return { ...state, updates: [action.update, ...state.updates] };
    default:
      return state;
  }
}
